import DrawingHistory from "../../api/DrawingStorage";
import { DrawEvent } from "../../events/DrawEvent";
import { HISTORY_DRAW_END } from "../../events/DrawEventType";
import { lock } from "../../util/StoreUtil";
export default class HistoryManager {
  constructor(drawCanvas, konvaLayer, concertId, numHistory, dropShadowLayer, dropShadowCanvas) {
    this.history = new DrawingHistory(concertId, numHistory);
    this.konvaLayer = konvaLayer;
    this.drawCanvas = drawCanvas;

    if (dropShadowLayer) {
      this.dropShadowLayer = dropShadowLayer;
      this.dropShadowCanvas = dropShadowCanvas;
      this.dropShadowHistory = new DrawingHistory(concertId, numHistory);
    }
  }

  fixDropshadow() {
    if (this.dropShadowLayer)
      this.setBase64(this.dropShadowHistory.getCurrent(), this.dropShadowCanvas);
  }

  drawn(isClear = false) {
    this.drawn_(isClear, this.drawCanvas, this.history);
    if (this.dropShadowLayer) {
      this.drawn_(isClear, this.dropShadowCanvas, this.dropShadowHistory);
    }
  }
  drawn_(isClear = false, canvas, history) {
    const base64 = isClear ? "clear" : canvas.getBase64();
    history.add(base64);
  }
  back() {
    this.setBase64(this.history.back(), this.drawCanvas);
    if (this.dropShadowLayer)
      this.setBase64(this.dropShadowHistory.back(), this.dropShadowCanvas);
  }
  forward() {
    this.setBase64(this.history.forward(), this.drawCanvas);
    if (this.dropShadowLayer)
      this.setBase64(this.dropShadowHistory.forward(), this.dropShadowCanvas);
  }

  load() {
    let item = this.history.load();
    this.setBase64(item.img, this.drawCanvas);
    return item;
  }

  save(position, texts) {
    this.history.save(this.drawCanvas.getBase64(), position, texts);
  }

  clear() {
    this.history.clear();
    if (this.dropShadowHistory)
      this.dropShadowHistory.clear();
    this.drawn();
  }

  finish() {
    this.clear();
  }

  setBase64(base64, canvas) {
    try {
      if (!base64) {
        lock(false);
        return;
      }

      // Clear時
      if (base64 == "clear") {
        canvas.clear();
        this.drawLayer();
      }
      //ちゃんとbase64あるとき
      else {
        canvas.setBase64(base64, () => {
          this.drawLayer();
        });
      }
    } catch (e) {
      alert(e);
    }
  }

  drawLayer() {
    lock(false);
    this.konvaLayer.batchDraw();
    if (this.dropShadowLayer)
      this.dropShadowLayer.batchDraw();
    // DrawEvent.emit(HISTORY_DRAW_END);
  }
}
